export const ORG_SELECT_CHANGED = 'onOrgSelectChanged'



// WEBPACK FOOTER //
// ./src/views/09System-Settings/02Org/EventKeys.js